<template>
	<div class="xs-12">
		<file-system-submenu :bucketName="id" />

		<core-layout-content large>
			<!-- File browser -->
			<file-browser :bucketName="id" />

			<!--
			<j-card v-if="!canRead" class="flex p4 xs-12"
				>You need readFiles permission to display the file browser.</j-card
			>
			-->
		</core-layout-content>
	</div>
</template>

<script>
import FileBrowser from "../components/FileBrowser"
import JCard from "@/components/JCard"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import FileSystemSubmenu from "../components/FileSystemSubmenu"

import { can } from "@/permissions/"

export default {
	name: "FileSystemDetail",

	components: {
		FileBrowser,
		JCard,
		CoreLayoutContent,
		FileSystemSubmenu
	},

	props: {
		// From router
		id: String
	},

	computed: {
		canRead() {
			return can("readFiles")
		}
	},

	data() {
		return {
			isLoading: false
		}
	}
}
</script>
